// import { useState, useMemo, useEffect, useCallback, useRef } from "react";
import { useState, useEffect, useMemo, useCallback, useRef } from "react";
// import { useNavigate, Link } from "react-router-dom";
import { AgGridReact } from "ag-grid-react";
import api from "api/api";

//Props Validations
import PropTypes from "prop-types";

// import mui components
import { styled } from "@mui/material/styles";
// import Button from "@mui/material/Button";

import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";

//import mui icon
// import OpenInNewIcon from "@mui/icons-material/OpenInNew";

//import assets
import productCategory from "../assets/icons/productCategory.png";
// import competitorProduct from "../assets/icons/competitorProduct.png";
import country from "../assets/icons/country.png";
import deodorantFormat from "../assets/icons/deodorantFormat.png";
import studyType from "../assets/icons/studyType.png";
import studyReference from "../assets/icons/studyReference.png";
import unileverProduct from "../assets/icons/unileverProduct.png";
import year from "../assets/icons/year.png";
import brand from "../assets/icons/brand.png";
// import documents from "../assets/icons/documents.png";

//import component
import ActionStandardTooltipData from "../components/common/ActionStandardTooltipData";
import FiltersHeaderLabel from "../components/common/FiltersHeaderLabel";
import Header from "../components/common/Header";
import Loader from "../components/common/Loader";
import StudiesFiltersComponent from "../components/studyPage/StudiesFiltersComponent";

// import MainNavigation from "../components/common/MainNavigation";

// import DashboardPanel from "../components/matchNet/landingPage/DashboardPanel";
import SearchBar from "../components/studyPage/SearchBar";
import CustomHeader from "../components/studyPage/CustomHeader";

import ReactCountryFlag from "react-country-flag";

//redux
import { useSelector, useDispatch } from "react-redux";
// import { loadSelectedStudiesState, loadProductTestCodeMapState, loadListedStudiesState, loadNavigationAvailabilityState } from "store/features/studyDataSlice";
// import { resetConsumerFilterStoreState } from "store/features/consumerFilterSlice";
// import { loadDataMappingDisplayLabelState, loadDataMappingBackendVariableMacroCategoryState, loadDataMappingBackendVariableVariableCategoryState } from "store/features/dataMappingSlice";
// import { resetAnalysisResultsStoreState, loadWeightToggleState, loadDisableWeightToggleState, loadProductColorsState, loadLikertScaleDataState } from "store/features/analysisResultsSlice";
// import { loadProductOrderState, loadDefaultProductOrderState, resetProductsInfoStore } from "store/features/productsInfoSlice";
// import { resetCorrelationStore } from "store/features/correlationSlice";
// import { resetClaimsAnalysisStore } from "store/features/claimsAnalysisSlice";
// import { loadTagsState } from "store/features/claimsMappingSlice";
// import { resetRespondentDashboardStoreState } from "store/features/respondentDashboardSlice";
// import { resetAnalysisKpiStoreState } from "store/features/analysisKpiSlice";
// import { resetAnalysisTypeSelectionStoreState } from "store/features/analysisTypeSelectionSlice";
import { loadStudyFiltersFlagState } from "store/features/studyDataSlice";
import { showNotification } from "store/features/notificationSlice";
import { loadSelectedProductsState } from "store/features/matchNetSlice";

import GetIconHeader from "../utils/GetIconHeader";
import FullScreenConatiner from "../components/layouts/FullScreenConatiner";
import MatchNetNavigation from "../components/common/MatchNetNavigation";
// import GenerateColors from "../utils/charts/GenerateColors";
// import GetNavigationButtons from "../utils/GetNavigationButtons";

const NoMaxWidthTooltip = styled(({ className, ...props }) => (
    <Tooltip
        {...props}
        classes={{ popper: className }}
        placement="right"
    />
))({
    [`& .${tooltipClasses.tooltip}`]: {
        maxWidth: "none",
        background: "linear-gradient(90deg, rgba(191, 242, 255, 1) 0%, rgba(195, 215, 255, 1) 100%)",
        borderRadius: "5px",
        padding: "5px 0px",
    },
});

const ActTool = ({ style, data, studyType, studyTypeMethod }) => {
    return (
        <NoMaxWidthTooltip
            title={
                <div>
                    <ActionStandardTooltipData
                        data={data}
                        onlyKpi={true}
                        studyType={studyType}
                        studyTypeMethod={studyTypeMethod}
                    />
                </div>
            }
        >
            <div
                style={{
                    ...style,
                    marginBottom: "8px",
                }}
            ></div>
        </NoMaxWidthTooltip>
    );
};

// Typechecking props for the Study
ActTool.propTypes = {
    style: PropTypes.object,
    data: PropTypes.array,
    studyType: PropTypes.string,
    studyTypeMethod: PropTypes.string,
};

// const ovalStyleYellow = {
//     display: "inline-block",
//     width: "1.5em",
//     height: "1.5em",
//     borderRadius: "50%",
//     backgroundColor: "#FFBF00",
//     marginRight: "10px",
//     cursor: "pointer",
// };

// const parseResult = (result) => {
//     if (!result) return {};
//     try { return typeof result === "object" ? result : JSON.parse(result); }
//     catch { return {}; }
// };

// const isParity = (datum) => Object.values(parseResult(datum?.action_standard_groups?.result)).some((v) => v?.toLowerCase() === "parity");

function MatchNetLandingPage({ headerTitle = "" }) {
    const dispatch = useDispatch();
    const gridRef = useRef();
    const latestMatchNetRequest = useRef(0);
    // const navigate = useNavigate();
    // const isInitialMount = useRef(true);

    const studyPageFilters = useSelector((state) => state.studyDataStore.studyPageFilters);
    const productCategoryData = useSelector((state) => state.settingsStore.productCategory);
    const productCategoryId = productCategoryData?.value || null;
    const filteredCoreDataIdsFromSearchFilters = useSelector((state) => state.studyDataStore.filteredCoreDataIdsFromSearchFilters);
    const algorithm = useSelector((state) => state.matchNetStore.selectedStudyType);
    const selectedProductsState = useSelector((state) => state.matchNetStore.selectedProducts);

    const [rowData, setRowData] = useState([]);
    const [rowsToListInGrid, setRowsToListInGrid] = useState([]);
    const [selectedRow, setSelectedRow] = useState([]);
    const [selectedProductRows, setSelectedProductRows] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const handleStudyTypeHeaderSelection = (checked) => {
        if (!gridRef.current) return;
        if (checked) {
            gridRef.current.api.selectAll();
        } else {
            gridRef.current.api.deselectAll();
        }
    };

    const prodCol = [
        {
            headerName: "Product Matches Across Workstreams (MatchNet)",
            field: "product_matches_across",
            filter: "agTextColumnFilter",
            checkboxSelection: (params) => !rowData[params.data.id],
            // headerCheckboxSelection: () => selectedRow.length > 0,
            // headerCheckboxSelection: true,
            // headerCheckboxSelectionFilteredOnly: true,
            // headerComponent: HeaderCheckbox,
            // headerComponentParams: {
            //     template: GetIconHeader("Product Matches Across Workstreams (MatchNet)", productCategory),
            // },
            sortable: true,
            suppressMovable: false,
            minWidth: 250,
            headerComponent: CustomHeader,
            headerComponentParams: {
                displayName: "Product Matches Across Workstreams (MatchNet)",
                icon: productCategory,
                enableCheckbox: true,
                onHeaderCheckboxChanged: handleStudyTypeHeaderSelection,
                checkStatus: rowsToListInGrid.length > 0 && selectedProductRows.length === rowsToListInGrid.length,
            },
        },
        {
            headerName: "Product Match",
            field: "product_match",
            minWidth: 450,
            headerComponentParams: {
                template: GetIconHeader("Product Match", unileverProduct),
            },
        },
        {
            headerName: " Study Period",
            field: "study_period",
            minWidth: 250,
            // sort: "desc",
            // comparator: dateComparator,
            headerComponentParams: {
                template: GetIconHeader("Study Period", year),
            },
            valueFormatter: function (params) {
                const updatedDateFormat = params.value.split("/");
                return updatedDateFormat[1] + "/" + updatedDateFormat[0]; // Date format changed to mm/yyyy
            },
        },
        {
            headerName: "Brand",
            field: "brand",
            minWidth: 250,
            // cellRenderer: multipleCellRenderer,
            autoHeight: true,
            wrapText: true,
            headerComponentParams: {
                template: GetIconHeader("Brand", brand),
            },
        },
        {
            headerName: "Product Format",
            field: "product_format",
            minWidth: 250,
            // cellRenderer: multipleCellRenderer,
            autoHeight: true,
            wrapText: true,
            headerComponentParams: {
                template: GetIconHeader("Product Format", deodorantFormat),
            },
        },
        {
            headerName: "Country",
            minWidth: 250,
            field: "country",
            cellRenderer: (params) => {
                return (
                    <div>
                        <ReactCountryFlag
                            countryCode={params.data.country__description}
                            svg
                            style={{
                                width: "1.5em",
                                height: "1.5em",
                                marginRight: "10px",
                            }}
                        />
                        <span>{params.data.country}</span>
                    </div>
                );
            },
            headerComponentParams: {
                template: GetIconHeader("Country", country),
            },
        },
        {
            headerName: "Study Type Method",
            field: "study_type_method",
            minWidth: 250,
            headerComponentParams: {
                template: GetIconHeader("Study Type Method", studyType),
            },
        },
        {
            headerName: "Research Design Type",
            field: "research_design_type",
            minWidth: 250,
            headerComponentParams: {
                template: GetIconHeader("Research Design Type", studyType),
            },
        },
        {
            headerName: "Study Reference",
            field: "study_reference__title",
            minWidth: 250,
            autoHeight: true,
            wrapText: true,
            headerComponentParams: {
                template: GetIconHeader("Study Reference", studyReference),
            },
        },
    ];

    const columnDefs = prodCol;
    const defaultColDef = useMemo(() => {
        return {
            editable: false,
            suppressMenu: true,
            sortable: true,
            filter: true,
            resizable: true,
            floatingFilter: true,
            filterParams: {
                filterOptions: ["contains"], // to get filter remove class .ag-floating-filter-button  form css
                // filterOptions: ["equals", "contains", "startsWith", "endsWith"], // to get filter remove class .ag-floating-filter-button  form css
            },
            cellStyle: { fontSize: "12px", border: "none", paddingTop: "5px" },
            minWidth: 200,
        };
    }, []);

    const getFilterQueryString = () => {
        let queryString = productCategoryId ? `product_category=${productCategoryId}` : "";
        if (Object.keys(studyPageFilters).length > 0 && studyPageFilters && Object.keys(studyPageFilters).length > 0) {
            Object.keys(studyPageFilters).forEach((filter) => {
                let checkedValue = "";
                let _filter = filter;
                studyPageFilters[_filter].forEach((datum) => {
                    if (datum.checked) {
                        if (checkedValue !== "") {
                            checkedValue += ",";
                        }
                        if (_filter === "studyPeriod") {
                            checkedValue += datum.label;
                        } else {
                            checkedValue += datum.value;
                        }
                    }
                });
                if (checkedValue !== "") {
                    if (queryString !== "") {
                        queryString += "&";
                    }

                    if (_filter === "studyType") {
                        _filter = "study_type";
                    } else if (_filter === "studyTypeMethod") {
                        _filter = "study_type_method";
                    } else if (_filter === "deodorantFormat") {
                        _filter = "deodorant_format";
                    } else if (_filter === "studyPeriod") {
                        _filter = "study_period__title";
                    } else if (_filter === "unileverBrand") {
                        _filter = "unilever_brand";
                    } else if (_filter === "country") {
                        _filter = "country";
                    } else {
                        _filter = "";
                    }

                    queryString += _filter + "=" + checkedValue;
                }
            });
        }
        return queryString;
    };

    const fetchMatchNetAnalysisRows = () => {
        const requestId = ++latestMatchNetRequest.current;
        const filterQueryString = getFilterQueryString();
        const url = process.env.REACT_APP_SERVER_PATH + `/deodrants-match-net-analysis/filtered/?archive=false&parsed=true&` + filterQueryString + `&algorithm=` + algorithm;
        setIsLoading(true);
        try {
            api.get(url)
                .then(async (res) => {
                    if (requestId !== latestMatchNetRequest.current) return;
                    const productsData = res?.data || [];
                    const sortedData = productsData.sort((a, b) => b.product_matches_across - a.product_matches_across);
                    setRowData(sortedData);
                    // dispatch(loadStudyFiltersFlagState(false));
                    setIsLoading(false);
                })
                .catch(async (error) => {
                    if (requestId !== latestMatchNetRequest.current) return;
                    handleError("error", error);
                    setIsLoading(false);
                });
        } catch (error) {
            handleError("error", error);
            setIsLoading(false);
        }
    };

    const fetchCoreDataRows = () => {
        const filterQueryString = getFilterQueryString();
        const url = process.env.REACT_APP_SERVER_PATH + `/core-data-models/?archive=false&parsed=true&` + filterQueryString;
        setIsLoading(true);
        try {
            api.get(url)
                .then(async (res) => {
                    const sortedDataByStudyPeriod = (res?.data || []).sort((a, b) => {
                        // Parse the study_period__title to get year and month
                        const [yearA, monthA] = (a?.study_period__title || "").split("/").map(Number);
                        const [yearB, monthB] = (b?.study_period__title || "").split("/").map(Number);

                        // Create comparable values (higher value for more recent dates)
                        const dateA = new Date(yearA, monthA); // monthA will be 0-indexed
                        const dateB = new Date(yearB, monthB);

                        // Compare dates for sorting in descending order
                        if (dateA !== dateB) {
                            return dateB - dateA; // Sort years in descending order
                        }
                        return dateB - dateA; // For descending order
                    });
                    setSelectedRow(sortedDataByStudyPeriod);
                    dispatch(loadStudyFiltersFlagState(false));
                    setIsLoading(false);
                })
                .catch(async (error) => {
                    handleError("error", error);
                    setIsLoading(false);
                });
        } catch (error) {
            handleError("error", error);
            setIsLoading(false);
        }
    };

    const handleFiltersSubmit = () => {
        fetchMatchNetAnalysisRows();
        fetchCoreDataRows();
    };

    // useEffect(() => {
    //     fetchMatchNetAnalysisRows();
    // }, [algorithm]);

    useEffect(() => {
        handleFiltersSubmit();
    }, [algorithm]);

    useEffect(() => {
        const filteredIds = filteredCoreDataIdsFromSearchFilters?.map(Number) || null;
        if (filteredIds) {
            if (filteredIds.length) {
                const data = rowData.filter((datum) => filteredIds.includes(datum.core_data_id));
                setRowsToListInGrid([...data]);
                // dispatch(loadListedStudiesState([...data]));
            } else {
                setRowsToListInGrid([]);
                // dispatch(loadListedStudiesState([]));
            }
        } else {
            setRowsToListInGrid([...rowData]);
            // dispatch(loadListedStudiesState([...rowData]));
        }
    }, [rowData, filteredCoreDataIdsFromSearchFilters, dispatch]);

    // useEffect(() => {
    //     if (selectedProductsState.length === 0) {
    //         setSelectedProductRows([]);
    //     }   
    // }, [selectedProductsState]);

    const onSelectionChanged = useCallback(() => {
        let _selectedProductRows = gridRef.current.api.getSelectedRows();
        setSelectedProductRows(_selectedProductRows);
        dispatch(loadSelectedProductsState(_selectedProductRows || []));
    }, [dispatch]);

    const handleError = (type, error) => {
        dispatch(showNotification({ severity: type, data: error }));
    };

    const selectRows = useCallback(() => {
        const rowsToSelect = selectedProductsState?.map((ele) => ele.product_a_id);
        const selected = [];
        gridRef?.current?.api.forEachNode(function (node) {
            if (node.data && rowsToSelect?.includes(node.data.product_a_id)) {
                selected.push(node);
            }
            gridRef?.current?.api.setNodesSelected({ nodes: selected, newValue: true });
        });
    }, [selectedProductsState]);

    return (
        <div>
            <Header
                title={headerTitle}
                titleSuffix={algorithm !== "" ? (algorithm === "home_use_test" ? "(Home Use Test Compatibility Context)" : "(Fragrance Testing Compatibility Context)") : ""}
                isStudySelected={false}
            />
            {isLoading && <Loader />}

            <div
                style={{
                    display: "flex",
                    marginTop: 11,
                    marginBottom: 0,
                    justifyContent: "space-between",
                }}
                className="ms-4 mb-0 me-4"
            >
                <div
                    className=" background-color-white box-shadow--2 d-flex"
                    style={{
                        borderRadius: "5px",
                        minWidth: "calc(100vw - 50px)",
                    }}
                >
                    <StudiesFiltersComponent
                        handleFiltersSubmit={handleFiltersSubmit}
                        studiesRoute="/studies"
                        defaultOpen={false}
                    />
                    <FiltersHeaderLabel multipleLabel={true} />
                </div>
            </div>
            <FullScreenConatiner>
                <div
                    style={{
                        display: "flex",
                    }}
                >
                    <div
                        style={{
                            minWidth: "100%",
                            minHeight: "calc(100vh - 168px)",
                        }}
                        className=" landing-page-table p-2 mb-0"
                    >
                        <div>
                            <SearchBar
                                listedStudies={selectedRow}
                                allStudies={selectedRow}
                                selectedRows={selectedRow}
                                showFormulationButton={false}
                            />
                        </div>
                        <div
                            className="ag-theme-alpine"
                            style={{
                                height: "calc(100vh - 365px)",
                                width: "100%",
                                position: "relative",
                            }}
                        >
                            <style>
                                {`
                                .ag-header-group-cell-label {
                                    justify-content: center !important;
                                }
                                .ag-header-cell-comp-wrapper {
                                    justify-content: center !important;
                                }
                                `}
                            </style>
                            <AgGridReact
                                rowStyle={{
                                    background: "white",
                                }}
                                ref={gridRef}
                                rowSelection="multiple"
                                rowMultiSelectWithClick={true}
                                defaultColDef={defaultColDef}
                                rowData={rowsToListInGrid}
                                columnDefs={columnDefs}
                                onGridReady={(params) => params.product_a_id}
                                // onGridReady={onGridReady}
                                onSelectionChanged={onSelectionChanged}
                                // sideBar={true}
                                rowHeight={30}
                                headerHeight={60}
                                floatingFiltersHeight={40}
                                suppressDragLeaveHidesColumns={true}
                                // sortingOrder={sortingOrder}
                                // onFirstDataRendered={onFirstDataRendered}
                                // onBodyScroll={onBodyScroll}
                                onRowDataUpdated={() => selectRows()}
                                suppressRowClickSelection={true}
                            ></AgGridReact>
                        </div>
                        <div className="d-flex mt-1">
                            <span
                                className="text-xxs"
                                style={{
                                    color: "#495057",
                                    marginRight: 20,
                                    fontWeight: 600,
                                }}
                            >
                                Selected rows: {selectedProductsState.length}
                            </span>
                            <span
                                className="text-xxs"
                                style={{
                                    color: "#495057",
                                    fontWeight: 600,
                                }}
                            >
                                Total rows: {rowsToListInGrid.length}
                            </span>
                        </div>
                    </div>
                </div>
                <div
                    style={{
                        position: "relative",
                        bottom: 0,
                        zIndex: 10,
                        top: "5px",
                    }}
                >
                    <MatchNetNavigation
                        buttons={["matchNetLookup"]}
                        isDisabled={selectedProductsState.length === 0}
                    />
                </div>
            </FullScreenConatiner>
        </div>
    );
}

// Typechecking props for the Study
MatchNetLandingPage.propTypes = {
    headerTitle: PropTypes.string,
};

export default MatchNetLandingPage;
